var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagVenezuela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4124 23.2272C31.4296 21.1237 32 18.7639 32 16.2707C32 13.7775 31.4296 11.4177 30.4124 9.31416L16 7.92285L1.58763 9.31416C0.570438 11.4177 0 13.7775 0 16.2707C0 18.7639 0.570438 21.1237 1.58763 23.2272L16 24.6185L30.4124 23.2272Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 32.2706C22.3436 32.2706 27.8246 28.579 30.4126 23.2271H1.58789C4.17589 28.579 9.65689 32.2706 16.0003 32.2706Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7105 19.4113L26.8654 20.0717L27.2322 21.0792L26.343 20.4797L25.4979 21.1399L25.7934 20.109L24.9043 19.5092L25.9761 19.4719L26.2719 18.4409L26.6387 19.4487L27.7105 19.4113Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5467 15.6631L24.9785 16.5727L25.668 17.394L24.6273 17.1349L24.0589 18.0442L23.984 16.9744L22.9434 16.7149L23.9379 16.313L23.8632 15.2432L24.5525 16.0649L25.5467 15.6631Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2313 12.8809L22.0084 13.9299L22.9372 14.4662L21.8706 14.5786L21.6476 15.6274L21.2113 14.6477L20.1447 14.7597L20.9418 14.042L20.5056 13.0624L21.4343 13.5985L22.2313 12.8809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1643 11.4009L18.3137 12.4629L19.3698 12.6491L18.4059 13.1194L18.5552 14.1814L17.8102 13.4099L16.8461 13.8801L17.3497 12.933L16.6047 12.1616L17.6609 12.3478L18.1643 11.4009Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8365 11.4009L14.34 12.3478L15.396 12.1615L14.6512 12.9332L15.1545 13.8802L14.1907 13.4099L13.4455 14.1813L13.595 13.1194L12.631 12.6493L13.6872 12.4629L13.8365 11.4009Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76916 12.8809L10.5663 13.5985L11.4949 13.0624L11.0588 14.0424L11.8557 14.7599L10.7892 14.6477L10.3528 15.6274L10.1301 14.5784L9.06348 14.4664L9.99223 13.93L9.76916 12.8809Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45407 15.6629L7.44863 16.0647L8.13776 15.2432L8.06319 16.3132L9.05744 16.715L8.01688 16.9744L7.94194 18.044L7.37382 17.1347L6.33313 17.394L7.0225 16.5725L6.45407 15.6629Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29004 19.4112L5.36204 19.4485L5.72866 18.4409L6.0246 19.4719L7.09629 19.5094L6.20716 20.1091L6.50266 21.14L5.65766 20.4797L4.76848 21.0793L5.13529 20.0715L4.29004 19.4112Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4126 9.31401C27.8246 3.96207 22.3436 0.270508 16.0003 0.270508C9.65689 0.270508 4.17589 3.96207 1.58789 9.31401H30.4126Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16887"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagVenezuela);
export default __webpack_public_path__ + "static/media/flag_venezuela.a6a6f0d5671aa637ba5f6f94149054d8.svg";
export { ForwardRef as ReactComponent };